module.exports = __webpack_public_path__ + "img/book.53c72120.svg";